import React, { useEffect, useState } from "react";
import PageTitle from "../components/PageTitle";
import apiService from "../core/service/detail";
import { postMethod } from "../core/service/common.api";
// import Pagination from "react-js-pagination";
import useStyles from "../components/Header/styles";
import Pagination from "@material-ui/lab/Pagination";
import moment from "moment";
import { CircularProgress, Typography } from "@material-ui/core";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";

function Subscribe() {
  const [viewData, setviewData] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPage, settotalPage] = useState(0);
  const [BlocksentelsviewData, setBlocksentelsviewData] = useState([]);
  const [BlocksentelscurrentPage, setBlocksentelscurrentPage] = useState(1);
  const [BlocksentelstotalPage, setBlocksentelstotalPage] = useState(0);
  const [pageloader, setpageloader] = useState(true);
  const [pageloaderBlock, setpageloaderBlock] = useState(true);

  const [open, setOpen] = useState(false);
  const [viewcontact, setviewcontact] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  var classes = useStyles();
  const recordPerPage = 5;
  const totalRecords = 15;
  const pageRange = 5;

  const BlocksentelsrecordPerPage = 5;
  const BlocksentelstotalRecords = 15;
  const BlocksentelspageRange = 5;

  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
    setcurrentPage(pageNumber);
    // setchoosepage()
  };
  const BlocksentelshandlePageChange = (pageNumber) => {
    getBlocksentelsData(pageNumber);
    setBlocksentelscurrentPage(pageNumber);
    // setchoosepage()
  };

  useEffect(() => {
    getData();
    getBlocksentelsData();
  }, []);

  const getBlocksentelsData = async (page, search = "") => {
    var payload = {
      perpage: 5,
      page: page,
      search,
    };
    var list = {
      apiUrl: apiService.getBlocksentelSubscribelist,
      payload: payload,
    };
    setpageloaderBlock(true);
    var resp = await postMethod(list);
    setpageloaderBlock(false);
    console.log(resp.data);
    setBlocksentelsviewData(resp.data.data);
    setBlocksentelstotalPage(resp.data.pages);
  };
  const getData = async (page, search = "") => {
    var payload = {
      perpage: 5,
      page: page,
      search,
    };
    var list = {
      apiUrl: apiService.Subscribelist,
      payload: payload,
    };
    setpageloader(true);
    var resp = await postMethod(list);
    setpageloader(false);
    console.log(resp.data);
    setviewData(resp.data.data);
    settotalPage(resp.data.pages);
  };
  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
        <PageTitle title=" Beleaf Subscribe List" className="mob_mb_10" />
        <SearchBar
          placeholder="Search by Email"
          onSearch={(term) => getData(1, term)}
        />
      </div>
      <div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Email </th>
                  <th> Date </th>
                </tr>
              </thead>
              <tbody className="admin_tbody">
                {" "}
                {pageloader === true ? (
                  Array.from({ length: 5 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : viewData.length > 0 ? (
                  viewData.map((data, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{data.email}</td>
                        <td>{moment(data.createdAt).format("lll")}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={9}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* <Pagination
                    itemClass="page-item" // add it for bootstrap 4
                    linkClass="page-link" // add it for bootstrap 4
                    activePage={currentPage}
                    itemsCountPerPage={recordPerPage}
                    totalItemsCount={totalPage}
                    pageRangeDisplayed={pageRange}
                    onChange={handlePageChange}
                /> */}

        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
        <PageTitle title=" Blocksentels Subscribe List" className="mob_mb_10" />
        <SearchBar
          placeholder="Search by Email"
          onSearch={(term) => getBlocksentelsData(1, term)}
        />
      </div>
      <div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Email </th>
                  <th> Date </th>
                </tr>
              </thead>
              <tbody className="admin_tbody">
                {pageloaderBlock === true ? (
                  Array.from({ length: 5 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : BlocksentelsviewData.length > 0 ? (
                  BlocksentelsviewData.map((data, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{data.email}</td>
                        <td>{moment(data.createdAt).format("lll")}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={9}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* <Pagination
          itemClass="page-item" // add it for bootstrap 4
          linkClass="page-link" // add it for bootstrap 4
          activePage={BlocksentelscurrentPage}
          itemsCountPerPage={BlocksentelsrecordPerPage}
          totalItemsCount={BlocksentelstotalPage}
          pageRangeDisplayed={BlocksentelspageRange}
          onChange={BlocksentelshandlePageChange}
        /> */}
        {BlocksentelstotalPage > 1 && (
          <Pagination
            count={BlocksentelstotalPage}
            page={BlocksentelscurrentPage}
            onChange={(e, value) => BlocksentelshandlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
      </div>
    </>
  );
}

export default Subscribe;
